import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaginationService } from 'ngx-pagination';
import { format } from 'util';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Modals } from 'app/shared/constants/modals';
import { Sections } from 'app/shared/constants/sections';
import { ModuleService } from 'app/shared/services/module.service';
import { SectionService } from 'app/shared/services/section.service';
import { Module } from 'app/shared/models/module.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modules-list',
  templateUrl: './modules-list.component.html',
  styleUrls: ['./modules-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class ModulesListComponent extends ListBaseComponent implements OnInit {

  fieldCollection = [
    {name: 'IsActive', displayName: 'modules.isActiveFieldTitle', canSort: true, displayClass: ""},
    {
      name: 'ModuleId',
      displayName: 'modules.moduleIdFieldTitle',
      canSort: true,
      displayClass: "d-none d-lg-table-cell"
    },
    {name: 'Name', displayName: 'modules.nameFieldTitle', canSort: true, displayClass: ""},
    {
      name: 'DefaultTransactionFee',
      displayName: 'modules.defaultTransactionFeeFieldTitle',
      canSort: true,
      displayClass: "d-none d-sm-table-cell"
    },
    {
      name: 'DefaultRefundCost',
      displayName: 'modules.defaultRefundCostFieldTitle',
      canSort: true,
      displayClass: "d-none d-lg-table-cell"
    }
  ];

  private confirmDeactivateModuleMessage: string;
  private moduleActivatedMessage: string;
  private moduleDeactivatedMessage: string;

  constructor(protected sectionService: SectionService, protected moduleService: ModuleService, protected modalService: NgbModal, protected translateService: TranslateService) {
    super(sectionService, Sections.Modules, modalService, Modals.ModuleComponent);
  }

  ngOnInit() {
    super.initializeView(Constants.Modules_List_DefaultSortField, Constants.Modules_List_DefaultSortDirectionAscending);
    this.translateService.get(['modules.confirmDeactivateModuleMessage', 'modules.moduleActivatedMessage', 'modules.moduleDeactivatedMessage'])
      .subscribe(translations => {
        this.confirmDeactivateModuleMessage = translations['modules.confirmDeactivateModuleMessage'];
        this.moduleActivatedMessage = translations['modules.moduleActivatedMessage'];
        this.moduleDeactivatedMessage = translations['modules.moduleDeactivatedMessage'];
      });
  }

  handleBooleanToggleFilterChanged(newValue: boolean) {
    this.filterBase.ShowActiveAndInActiveItems = newValue;
    this.getCollection();
  }

  activate(module: Module) {
    this.moduleService.activateNow("/module/activate/" + module.ModuleId, () => this.getCollection(), this.moduleActivatedMessage)
  }

  deactivate(module: Module) {
    if (confirm(format(this.confirmDeactivateModuleMessage, module.Name))) {
      this.moduleService.deactivateNow("/module/deactivate/" + module.ModuleId, () => this.getCollection(), this.moduleDeactivatedMessage)
    }
  }

  getCollection(pageNumber: number = 1) {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.moduleService.getCollectionPaginated<Module>("/module", this.pageConfiguration, this.filterBase, (collection) => {
      this.collection = collection
    });
  }
}
